import mainSidenav from "./mainSidenav.component";

const mainSidenavModule = angular
  .module("app.components.mainSidenav", [])
  .component("mainSidenav", mainSidenav);

export default mainSidenavModule;



// WEBPACK FOOTER //
// ./src/components/mainSidenav/mainSidenav.module.js